<template>
  <div v-if="score && !hasEssentials">
    <GridHighlight
      type="stability"
      :dark="false"
      :text="score"
      :minScore="minScore"
      :maxScore="maxScore"
      :scoreDelta="scoreDelta"
      :large-text="true"
      class="ml-3"
      :show-title="showTitle"
    ></GridHighlight>
  </div>
</template>

<script>
import lodashGet from "lodash/get";

import { hasEssentialsAccess } from "@/services/user/user.service";
import { getStabilityDelta } from "@/services/grids/stability.service";

export default {
  name: "RisksPulse",
  components: {
    GridHighlight: () => import("@/components/grids/GridHighlight"),
  },
  props: {
    selectedLocation: {
      type: Object,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hasEssentials: hasEssentialsAccess(),
      stability: null,
    };
  },
  computed: {
    score() {
      let result = null;
      if (lodashGet(this.stability, "Item.count")) {
        result = this.stability.Item.count;
      }

      if (typeof result === "number") {
        // need to use Math.floor because the map color styling doesn't round at all so
        // 59.99 still will show yellow instead of green which is 60
        result = Math.floor(result);
      }
      return result;
    },
    minScore() {
      if (
        typeof lodashGet(this.stability, "Item.stats.percentiles.very_low") ===
        "number"
      ) {
        const min = this.stability.Item.stats.percentiles.very_low;
        return min < 1 ? min : Math.floor(min);
      }
      return null;
    },
    maxScore() {
      if (
        typeof lodashGet(this.stability, "Item.stats.percentiles.very_high") ===
        "number"
      ) {
        return Math.floor(this.stability.Item.stats.percentiles.very_high);
      }
      return null;
    },
    scoreDelta() {
      if (lodashGet(this.stability, "Item.scoreDelta")) {
        return Math.floor(this.stability.Item.scoreDelta);
      }
      return 0;
    },
  },
  methods: {
    async getStability() {
      this.stability = null;
      if (this.selectedLocation) {
        const result = await getStabilityDelta({
          locationType: "country",
          numDays: 1,
        });
        if (result && result.pulseTiles) {
          for (let i = 0; i < result.pulseTiles.length; i++) {
            const country = result.pulseTiles[i];
            if (
              country.aoiId.toLowerCase() ===
              this.selectedLocation.iso2Code.toLowerCase()
            ) {
              this.stability = {
                Item: country,
              };
              break;
            }
          }
        }
      }
    },
  },
  watch: {
    selectedLocation: {
      handler() {
        if (this.selectedLocation && this.selectedLocation.iso2Code) {
          this.getStability();
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped></style>
